import {
  reportNameMessages,
  SAVED_REPORT_TYPE_TO_PATH_SEGMENT,
  SavedReportListType,
} from '@app/modules/audit/modules/reports/constants';
import { adminAuditPaths } from '@app/modules/audit/routing/admin-audit-paths';
import { BreadcrumbItem } from '@mi-front/ui';
import { MessageDescriptor } from 'react-intl';

export interface BreadcrumbItemConfig {
  href?: string;
  message: MessageDescriptor;
  active?: boolean;
}

export const auditConfigBreadcrumbItem = (
  formatMessage: (descriptor: MessageDescriptor) => string,
): BreadcrumbItem => ({
  href: adminAuditPaths.root(),
  content: formatMessage({
    id: 'audit.reportDefinitions.templatesTitle',
    defaultMessage: 'Plantillas',
  }),
});

export const reportDefinitionsBreadcrumbItem = (
  formatMessage: (descriptor: MessageDescriptor) => string,
  reportType: string,
): BreadcrumbItem => {
  const reportNameMessage = reportNameMessages[reportType];

  return {
    href: adminAuditPaths.reportDefinitions(reportType),
    content: reportNameMessage
      ? formatMessage(reportNameMessage)
      : formatMessage({
          id: 'audit.reportDefinitionList.title',
          defaultMessage: 'Plantillas de reporte',
        }),
  };
};

export const globalReportsBreadcrumbItem = (
  formatMessage: (descriptor: MessageDescriptor) => string,
): BreadcrumbItem => ({
  href: '/audit/global-reports',
  content: formatMessage({
    id: 'audit.globalReports.title',
    defaultMessage: 'Audit global',
  }),
});

export const createdReportsBreadcrumbItem = (
  formatMessage: (descriptor: MessageDescriptor) => string,
): BreadcrumbItem => ({
  href: '/audit/saved-reports',
  content: formatMessage({
    id: 'audit.reportsList.title',
    defaultMessage: 'Reportes guardados',
  }),
});

/**
 * Breadcrumb linking to the saved-reports list filtered by report type
 * (e.g. `/audit/saved-reports/broadcast-evidence`).
 */
export function savedReportsTypeBreadcrumbItem(
  formatMessage: (descriptor: MessageDescriptor) => string,
  reportType: string,
): BreadcrumbItem | undefined {
  const pathSegment = SAVED_REPORT_TYPE_TO_PATH_SEGMENT[reportType as SavedReportListType];
  const message = reportNameMessages[reportType];

  if (!pathSegment || !message) {
    return undefined;
  }

  return {
    href: `/audit/saved-reports/${pathSegment}`,
    content: formatMessage(message),
  };
}
